import { Http } from '../../../support';

const initialState = {
  busy: false,
  filters: {
    page: 1,
    search: '',
  },
  data: [],
  pagination: {
    limit: 25,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.reports.hitsUsage = {
      ...state.app.reports.hitsUsage,
      ...data,
    };
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.reports.hitsUsage = {
      ...state.app.reports.hitsUsage,
      filters: {
        ...state.app.reports.hitsUsage.filters,
        ...meta,
      },
      pagination: {
        ...state.app.reports.hitsUsage.pagination,
        limit: meta.limit ?? 25,
      },
      busy: true,
    };
  });

  const { filters, pagination } = store.state.app.reports.hitsUsage;

  try {
    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
    };

    const response = await Http.get('app/empresas/hits', { params });

    store.setState((state) => {
      state.app.reports.hitsUsage = {
        ...state.app.reports.hitsUsage,
        data: response.data,
        busy: false,
        pagination: {
          ...state.app.reports.hitsUsage.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.reports.hitsUsage.busy = false;
      state.app.reports.hitsUsage.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.reports.hitsUsage = { ...initialState };
  });
};

const HitsUsageListStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    paginate,
    reset,
  },
};

export default HitsUsageListStore;
